export enum ShopPages {
  BasicInfo = 'basic-info',
}

export default ShopPages;
